import './../app/shared/operators';

import { of } from 'rxjs/observable/of';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { Action} from '@ngrx/store';
import { Effect, Actions } from '@ngrx/effects';

import * as r from '../actions/platform.actions';
import { Api } from '../providers/api/api';

@Injectable()
export class PlatformEffects {
  constructor(private actions$: Actions,
    private api: Api,
  ) {
  }

  @Effect()
  fetchFilters$: Observable<Action> = this.actions$
    .ofType(r.FETCH_PLATFORM_INFO)
    .map((action: r.FetchPlatformInfo) => {
      return action;
    })
    .switchMap((payload) => this.api.fetchPlatformInfo())
    .map(res => {
      return new r.FetchPlatformInfoSuccess(res);
    }).catch((err) => of(new r.FetchPlatformInfoFailure(err)));

}





// WEBPACK FOOTER //
// ./src/effects/platform.effects.ts